import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, ToastController } from '@ionic/angular';
import { BaseClass } from '../../classes/base';
import { TranslationService } from '../../services/translation.service';
import { User } from '@sentry/browser';
import { Evaluation360Service } from "../../../360-evaluation/360-evaluation.service";

@Component({
    selector: 'app-change-relationship-modal',
    templateUrl: './change-relationship.modal.html',
    styleUrls: ['./change-relationship.modal.scss']
})
export class ChangeRelationshipModal extends BaseClass implements OnInit {

    public userEvaluated: User;
    public evaluatorCycleParticipantId: number;
    public cycleId: number;
    public relation: string;
    public oldRelation: string;
    public relationshipTranslation = this._translationService.getTranslation("generic.manager");

    constructor(
            protected _toastController: ToastController,
            protected _translationService: TranslationService,
            private _modalController: ModalController,
            private _evaluationService: Evaluation360Service,
            private _navParams: NavParams,
    ) {
        super(_toastController, _translationService);
        this.userEvaluated = this._navParams.get('userEvaluated');
        this.oldRelation = this._navParams.get('relation');
        this.relation = this._navParams.get('relation');
        this.evaluatorCycleParticipantId = this._navParams.get('evaluatorCycleParticipantId');
        this.cycleId = this._navParams.get('cycleId');
    }

    ngOnInit() {
    }

    changeRelationship() {
        this.relation = this.relation === "360" ? this.relationshipTranslation:"360";
    }

    public async saveChangeRelationship() {
        let relationChanged = this.relation !== this.oldRelation;

        if (relationChanged) {
            this._evaluationService.changeRelationShipOn360Evaluation(
                    this.evaluatorCycleParticipantId, this.userEvaluated.userId, this.relation, this.cycleId
            ).subscribe(() => {
                this.dismiss(true);
            }, (error) => {
                this.notifyError(error);
                this.dismiss(false);
            });
        } else {
            await this.notify(this._translationService.getTranslation('360evaluation.relationshipDontChanged'), 'danger');
            this.dismiss(false);
        }
    }

    public dismiss(reload: boolean) {
        this._modalController.dismiss(reload);
    }
}
